import { Injectable } from '@angular/core';
import { SideMenuItem } from '@flux/design-system';
import { FeatureFlagsEnum } from '@generated/featureFlags.enum';
import { GlobalPermissionsEnum } from '@generated/permissions.enum';

/**
 * Extended SideMenuItem with permission and feature flag support
 */
export interface NavigationMenuItem extends Omit<SideMenuItem, 'hidden' | 'children'> {
  children?: NavigationMenuItem[];
  has_feature_flag?: `${FeatureFlagsEnum}`[] | FeatureFlagsEnum[];
  required_permissions?: GlobalPermissionsEnum[] | `${GlobalPermissionsEnum}`[];
}

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private navigations: NavigationMenuItem[] = [
    {
      id: 'meu-espaco',
      title: 'Meu espaço',
      url: 'meu-espaco',
      icon: { unselected: 'home-outline', selected: 'home-filled' },
    },
    {
      id: 'fluxos',
      title: 'Fluxos de trabalho',
      url: 'fluxos',
      icon: { unselected: 'view-kanban-outline', selected: 'view-kanban-outline' },
      required_permissions: ['global:pipes:read_all', 'global:pipes:read_limited'],
    },

    {
      id: 'banco-de-dados',
      title: 'Banco de dados',
      url: 'banco-de-dados',
      icon: { unselected: 'database-outline' },
      has_feature_flag: ['feature:database'],
      required_permissions: ['global:database:read_all', 'global:database:read_limited'],
    },
    {
      id: 'configuracoes',
      title: 'Configurações',
      withDivider: true,
      children: [
        {
          id: 'gerenciar-papeis',
          title: 'Papeis',
          url: 'gerenciar/papeis',
          icon: { unselected: 'shield-outline', selected: 'shield-filled' },
          withDivider: true,
          required_permissions: ['global:roles:manage_permissions'],
        },
        {
          id: 'gerenciar-pessoas',
          title: 'Pessoas',
          url: 'gerenciar/pessoas',
          icon: { unselected: 'peoples-outline', selected: 'peoples-filled' },
          required_permissions: ['global:roles:manage_users'],
        },
        {
          id: 'gerenciar-times',
          title: 'Times',
          url: 'gerenciar/times',
          has_feature_flag: ['feature:teams'],
          icon: { unselected: 'peoples-outline', selected: 'peoples-filled' },
          required_permissions: ['global:teams:read_all', 'global:teams:read_limited'],
        },
        {
          id: 'gerenciar-faturamento',
          title: 'Faturamento',
          url: 'gerenciar/faturamento',
          icon: { unselected: 'finance-outline', selected: 'finance-filled' },
          required_permissions: ['global:features:manage'],
        },
      ],
      icon: { unselected: 'settings-outline', selected: 'settings-filled' },
    },
  ];

  getNavigationItems(): NavigationMenuItem[] {
    return this.navigations;
  }
}
